import {
  userHasAnyPermission,
  userHasPermission,
  userHasRole,
} from './userPermissions'

export function canAccessPermissionRule(user, rule) {
  if (!rule) {
    return true
  }

  if (userHasRole(user, 'super')) {
    return true
  }

  const hasAnyPermission = rule.anyOf
    ? userHasAnyPermission(user, rule.anyOf)
    : true
  const hasAllPermission = rule.allOf
    ? rule.allOf.every((permissionName) => userHasPermission(user, permissionName))
    : true

  return hasAnyPermission && hasAllPermission
}

export function getMenuItemPermissionRule(menuItem, routePermissionResolver) {
  if (!menuItem) {
    return null
  }

  if (menuItem.permission) {
    return { anyOf: [menuItem.permission] }
  }

  if (menuItem.anyOf || menuItem.allOf) {
    return {
      anyOf: menuItem.anyOf,
      allOf: menuItem.allOf,
    }
  }

  return routePermissionResolver && menuItem.link
    ? routePermissionResolver(menuItem.link)
    : null
}

export function canAccessMenuItem(user, menuItem, routePermissionResolver) {
  return canAccessPermissionRule(
    user,
    getMenuItemPermissionRule(menuItem, routePermissionResolver)
  )
}

export function filterMenuItems(items = [], canAccess = () => true, isNested = false) {
  if (!Array.isArray(items)) {
    return []
  }

  return items.reduce((visibleItems, item) => {
    if (!canAccess(item, isNested)) {
      return visibleItems
    }

    if (Array.isArray(item.subItems)) {
      const subItems = filterMenuItems(item.subItems, canAccess, true)
      if (subItems.length === 0) {
        return visibleItems
      }
      visibleItems.push({ ...item, subItems })
      return visibleItems
    }

    visibleItems.push(item)
    return visibleItems
  }, [])
}
